import { SideBar } from '@/features/SideMenu'
import { Footer } from '@/components/footer/Footer'
import { css, Theme } from '@emotion/react'
import { ReactNode, useEffect } from 'react'

const basePageStyles = css`
  height: 100vh;
  display: flex;
  overflow: hidden;
`

const contentStyle = (t: Theme) => css`
  flex-grow: 1;
  background-color: #f8f9fa;
  width: 90%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`

const mainContentStyle = css`
  padding: 32px;
  flex-grow: 1;
`

type Props = {
  children: ReactNode
  title: string
}

export const BasePage = ({ children, title }: Props) => {
  useEffect(() => {
    document.title = title
  }, [title])

  return (
    <>
      <div css={basePageStyles}>
        <SideBar />
        <div css={contentStyle}>
          <main css={mainContentStyle}>{children}</main>
          <Footer />
        </div>
      </div>
    </>
  )
}
